import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RouterLinksService {

  constructor( private routes:Router ) {}

  setRouteScroll(path:string, value:number ){
    this.routes.navigateByUrl(path).then( result => {
      if (path === '/como-funciona') {
       this.windowScroll(value);
      }else {
        this.windowScroll(0);
      }
    });
  }

  private windowScroll(value:number) {
    window.scroll({
      top: value,
      behavior: 'smooth'
    });
  }

}
